import React from "react";
import { Container, Row, Col } from "reactstrap";
import VideoReviewList from "./VideoReviewList";

const Users = () => {
  return (
    <Container fluid className="p-0">
      <h1 className="page-title">Publishing Requests</h1>
      <Row>
        <Col lg="12" className="d-flex">
          <VideoReviewList />
        </Col>
      </Row>
    </Container>
  );
};

export default Users;
